// extracted by mini-css-extract-plugin
export default {"iconContainer":"style_iconContainer__gMcbb"};